import React from 'react';
import { products } from '../data/products';
import ProductGrid from '../components/collection/ProductGrid';
import SEO from '../components/seo/SEO';
import './CollectionPage.css';

const bodyProducts = products.filter((p) => p.category === 'body');

const BodyPage: React.FC = () => (
  <div className="collection-page">
    <SEO
      title="Body Care Collection"
      description="Natural body butters and body oils by Micah Lynise. Clean ingredients, handmade in small batches in Texas."
      path="/body"
    />
    <nav className="collection-page__breadcrumb" aria-label="Breadcrumb">
      <span>Home</span>
      <span aria-hidden="true"> / </span>
      <span>Body</span>
    </nav>

    <header className="collection-page__header">
      <h1 className="collection-page__title">Body</h1>
      <p className="collection-page__subtitle">
        Nourishing oils and whipped butters, each connected to a fragrance world.
      </p>
    </header>

    <div className="collection-page__toolbar">
      <span className="collection-page__count">{bodyProducts.length} products</span>
    </div>

    <ProductGrid products={bodyProducts} columns={3} />
  </div>
);

export default BodyPage;
